import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Typography from '../../Generic/Typography';
import { Button } from '../../Generic/Button';
import contentStyles from './RelatedCollection-tw-styles';
import { withLocale } from '../../Generic/LocaleProvider';
import globalConstants from '../../../constants/global';
import { getCdnImage } from '../../../utils/ImageManager';
import i18nMessages from '../../../constants/messages/pt-BR';
import DOMPurify from 'isomorphic-dompurify';

const urlJson = require('../../../data/pt-BR/url.json');

export class RelatedCollection extends React.PureComponent {
  render() {
    const { data } = this.props;
    let cardTypestyle = contentStyles[i18nMessages.contentdefault];
    if (data.styles && contentStyles[data.styles.trim()] !== undefined) {
      cardTypestyle = contentStyles[data.styles.trim()];
    }
    const slugRef = data.referencePageCollection.items[0].slug;
    let collection_url = slugRef
      ? urlJson[globalConstants.contentType.contentPage][slugRef].path
      : '';
    return (
      <div className={classNames(cardTypestyle)}>
        {data &&
          data.primaryImageCollection &&
          data.primaryImageCollection.items.length > 0 &&
          data.primaryImageCollection.items.map((imgData, index) => {
            return (
              <Button to={collection_url}>
                <img
                  className={classNames(contentStyles.primaryImage)}
                  key={index}
                  src={getCdnImage(imgData.image && imgData.image.url)}
                  alt={imgData.altText}
                />
              </Button>
            );
          })}
        <div className={classNames(contentStyles.contentWrapper)}>
          <Button
            to={collection_url}
            className={classNames(contentStyles.linkButton)}
          >
            {data &&
              data.secondaryImageCollection &&
              data.secondaryImageCollection.items.length > 0 &&
              data.secondaryImageCollection.items.map((imgData, index) => {
                return (
                  <img
                    className={classNames(contentStyles.secondaryImage)}
                    key={index}
                    src={getCdnImage(imgData.image && imgData.image.url)}
                    alt={imgData.altText}
                  />
                );
              })}
            <Typography
              component="div"
              className={classNames(contentStyles.title)}
              dangerouslySetInnerHTML={{
                __html:DOMPurify.sanitize( data && data.title),
              }}
            />
            <Typography
              component="div"
              className={classNames(contentStyles.subText)}
              dangerouslySetInnerHTML={{
                __html:DOMPurify.sanitize( data && data.text),
              }}
            />
          </Button>
        </div>
      </div>
    );
  }
}

RelatedCollection.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default withLocale(RelatedCollection);
